type CommentProps = {
  color?: string
}

function Comment({ color = '#777' }: CommentProps) {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="24"
      height="24"
      viewBox="0 0 24 24"
      aria-label="댓글"
    >
      <desc>댓글</desc>
      <path fill="none" d="M0 0h24v24H0z" data-name="Rectangle Copy 26"></path>
      <g data-name="그룹 9419" transform="translate(4.763 4.876)">
        <path
          fill="none"
          stroke={color}
          strokeMiterlimit="10"
          strokeWidth="1.5"
          d="M6.9.013A7.123 7.123 0 00.895 10.135a.528.528 0 01.032.369l-.914 3.224a.323.323 0 00.39.4l3.2-.809a.424.424 0 01.308.042A7.124 7.124 0 106.9.013z"
          data-name="패스 5075"
        ></path>
        <circle
          cx="1.15"
          cy="1.15"
          r="1.15"
          fill={color}
          data-name="타원 830"
          transform="translate(3.086 5.974)"
        ></circle>
        <circle
          cx="1.15"
          cy="1.15"
          r="1.15"
          fill={color}
          data-name="타원 831"
          transform="translate(6.042 5.974)"
        ></circle>
        <circle
          cx="1.15"
          cy="1.15"
          r="1.15"
          fill={color}
          data-name="타원 832"
          transform="translate(9.086 5.974)"
        ></circle>
      </g>
    </svg>
  )
}

export default Comment
